$.fn.dataTable.Summary = function (table, options) {
    let column = options.column;
    let api = $(table).DataTable().api();

    const calculate = () => {
        let result = api
            .column(column, { page: 'current' })
            .nodes()
            .reduce(function (a, b) {
                if (!isNaN(parseFloat(b.innerHTML))) {
                    return parseFloat(a) + parseFloat(b.innerHTML);
                }
                return a;
            }, 0);

        let footer = api.column(column).footer();
        $(footer).text(result);
    }

    calculate();
    $(table).on('draw.dt', function() {
        calculate();
    })
}

$.fn.DataTable.Summary = $.fn.dataTable.Summary;